import styled from "styled-components";
import { labels } from "../../../constants/labels";

export default function SatelliteInfo({ result }) {
  return (
    <SatelliteInfoStyled>
      <div className="title">Info</div>
      {Object.keys(result).map((item, index) => (
        <div className="item" key={index + item}>
          <div className="text">{labels[item]}: </div>
          {item === "area" ? <span>{Math.round(result[item])} m</span> : result[item].toFixed(8)}
        </div>
      ))}
    </SatelliteInfoStyled>
  );
}

const SatelliteInfoStyled = styled.div`
  position: absolute;
  bottom: 15px;
  left: 15px;
  background-color: white;
  padding: 20px;
  font-size: 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  z-index: 3;

  .title {
    font-weight: bold;
    margin-bottom: 10px;
  }

  .item {
    display: flex;
    justify-content: space-between;
    gap: 5px;

    .text {
      color: rgba(30, 30, 30, 0.5);
    }
  }
`;
